import type { FC } from 'react';
import { Navigate, useParams } from 'react-router';
import { useUserDetails } from '../api';
import EditUserForm from './EditUserForm';
import FormSkeleton from './FormSkeleton';
import { SuspenseBoundary } from 'components/common';
import GridErrorBoundaryFallback from './GridErrorBoundaryFallback';
import { ErrorBoundary } from 'react-error-boundary';

const EditUserComponent: FC = () => {
  const { userId } = useParams();
  const { data } = useUserDetails({ params: { id: Number(userId) } });

  if (!userId) return <Navigate to={'/'} />;
  return (
    <ErrorBoundary FallbackComponent={GridErrorBoundaryFallback}>
      <EditUserForm data={data} />
    </ErrorBoundary>
  );
};

const EditUser: FC = () => {
  return (
    <SuspenseBoundary fallback={<FormSkeleton />}>
      <EditUserComponent />
    </SuspenseBoundary>
  );
};

export default EditUser;
